import axios from "axios";

export default class WebPushApi {
  constructor(webPushApi) {
    this.client = axios.create();
    this.client.defaults.baseURL = webPushApi;
    this.client.defaults.headers["Content-Type"] = "application/json";
    this.client.defaults.withCredentials = true;
  }

  register = (token) =>
    this.client.post("/web_push_registration_info", {
      token,
      browser: navigator.userAgent,
    });

  registerSafari = (token) =>
    this.client.post("/safari/web_push_registration_info", {
      device_id: token,
      browser: navigator.userAgent,
    });

  unregister = (token) =>
    this.client.delete("/web_push_registration_info", {
      params: { token },
    });
}
